import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RequestPepclubCheckApiResponse } from "@core/models/api.response";
import { PepClubCheckDTO } from "@core/models/dto.models";
import { environment } from "@env/environment.development";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PepClubService {
  constructor(private http: HttpClient) {}

  checkIfPepClubOK(
    pepData: PepClubCheckDTO
  ): Observable<RequestPepclubCheckApiResponse> {
    return this.http.post<RequestPepclubCheckApiResponse>(
      `${environment.apiUri}/profile/msisdn/ok-for-pepclub`,
      pepData
    );
  }
}
